var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrypto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.683C12.91 5.25 13.925 5 15 5C18.866 5 22 8.134 22 12C22 15.866 18.866 19 15 19C13.925 19 12.91 18.75 12 18.317",
    fill: "#3152F5",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.683C12.91 5.25 13.925 5 15 5C18.866 5 22 8.134 22 12C22 15.866 18.866 19 15 19C13.925 19 12.91 18.75 12 18.317",
    stroke: "#3152F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9497 7.05025C16.6834 9.78392 16.6834 14.2161 13.9497 16.9497C11.2161 19.6834 6.78392 19.6834 4.05025 16.9497C1.31658 14.2161 1.31658 9.78392 4.05025 7.05025C6.78392 4.31658 11.2161 4.31658 13.9497 7.05025Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9497 7.05025C16.6834 9.78392 16.6834 14.2161 13.9497 16.9497C11.2161 19.6834 6.78392 19.6834 4.05025 16.9497C1.31658 14.2161 1.31658 9.78392 4.05025 7.05025C6.78392 4.31658 11.2161 4.31658 13.9497 7.05025",
    stroke: "#3152F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.00038L12.0002 12.0006L9 15.0008L5.99977 12.0006L9 9.00038Z",
    fill: "#3152F5",
    fillOpacity: 0.1,
    stroke: "#3152F5",
    strokeWidth: 1.49999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.f9d1b6f8d74f0fd152253037812c4c04.svg";
export { ForwardRef as ReactComponent };